module.exports = __webpack_public_path__ + "static/media/RecordingIconFocused.346d1394.svg";